import { useEffect } from 'react';
import { LinearProgress } from '@mui/material';
import { styled } from '@mui/material/styles';
import AWS from 'aws-sdk';
import { signOut } from 'components/signOut/SignOut';

const IframeContainer = styled('iframe')({
  width: '100%',
  height: '84vh',
  border: 'none',
});

const MainPage = () => {
    const clientId = process.env.REACT_APP_CLIENT_ID;
    const encReq = sessionStorage.getItem('documentID');
    const accToken = sessionStorage.getItem('accessToken');

    useEffect(() => {
        //making this call to check if the acces token is valid and the user is valid or not
        getUserAttributesFromAccessToken(accToken);
    }, []);

    const cognitoISP = new AWS.CognitoIdentityServiceProvider({
        region: 'ap-south-1' // Set your region
    });

    const getUserAttributesFromAccessToken = async (accessToken) => {
        if (!accessToken) {
            return null;
        }
        try {
            const response = await cognitoISP.getUser({ AccessToken: accessToken }).promise();

            const attributes = {};
            response.UserAttributes.forEach((attr) => {
                attributes[attr.Name] = attr.Value;
            });

            return attributes;
        } catch (error) {
            if (error.code === 'NotAuthorizedException' && error.message === 'Access Token has been revoked') {
                signOut();
            }

            return null;
        }
    };
    let IFRAME_URL = `${process.env.REACT_APP_ACCOUNT_HOLDER_URL}/#?encReq=${encReq}&clientId=${clientId}&JWT=${accToken}`;
    return (
        <>
            {encReq && encReq !== '' && !!accToken ? (
                // <iframe className={classes.iframeContainer} src={IFRAME_URL} allowFullScreen title="Account Holder App"></iframe>
                <IframeContainer src={IFRAME_URL} allowFullScreen title="Account Holder App" />

            ) : (
                <LinearProgress />
            )}
        </>
    );
};
export default MainPage;
